import { ToolbarIcon } from "./ToolbarIcon";

export const HeatMapToolbar = ({
	cameraPerspective,
	onToggleCamera,
	onZoomIn,
	onTogglePlay,
	onFullscreen,
	animationState,
	sideFilter,
	onToggleSide,
	onRestart,
	spotView,
	onToggleSpotView,
	cameraAngle,
	onToggleCameraAngle,
	zoomLevel,
	onZoomChange,
	isRecording,
	onToggleShare,
}) => {
	return (
		<>
			{/* Top toolbar */}
			<div className="absolute top-0 left-0 right-0 z-10 p-2 flex justify-between items-center">
				{/* Left side controls - Hidden during animation */}
				{animationState === "stopped" && (
					<div className="flex items-center gap-2">
						<button
							onClick={onToggleSpotView}
							className={`text-white px-3 py-1.5 rounded-md flex items-center gap-2 hover:bg-opacity-60 transition-colors bg-black bg-opacity-40`}
						>
							<ToolbarIcon iconName="SpotView" />
							{spotView ? "Spot view" : "Region view"}
						</button>
						<div className="flex items-center bg-black bg-opacity-40 rounded-md">
							<button
								onClick={() => onToggleCameraAngle("prev")}
								className=" text-white py-2 px-0.5 rounded-full hover:bg-opacity-60 transition-colors"
							>
								<ToolbarIcon iconName="CameraAngle1" />
							</button>
							<button
								onClick={onToggleCamera}
								className=" text-white py-2 px-0.5 rounded-full hover:bg-opacity-60 transition-colors"
							>
								<ToolbarIcon iconName="CameraAngle2" />
							</button>
							<button
								onClick={() => onToggleCameraAngle("next")}
								className=" text-white py-2 px-0.5 rounded-full hover:bg-opacity-60 transition-colors"
							>
								<ToolbarIcon iconName="CameraAngle3" />
							</button>
						</div>
					</div>
				)}
				{/* Magnifying Glass with Plus Icon - Always visible */}
				{/* <div className="bg-black bg-opacity-40 text-white p-2 rounded-full ml-auto">
          <ToolbarIcon iconName="ZoomIn" />
        </div> */}
			</div>

			{/* Right Side Vertical Zoom Slider */}
			<div className="absolute top-1/4 right-4 transform -translate-y-20 z-10">
				<div className="flex flex-col items-center gap-2">
					{/* Plus Button */}
					<button
						onClick={() => onZoomChange?.(Math.min(zoomLevel * 1.1, 1.5))}
						className="text-white p-1 hover:bg-white hover:bg-opacity-20 transition-colors rounded"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
						>
							<path d="M9 9V5H11V9H15V11H11V15H9V11H5V9H9Z" fill="white" />
						</svg>
					</button>

					{/* Vertical Slider Track */}
					<div className="relative h-20 flex items-center justify-center">
						{/* Slider Track Line */}
						<div className="w-0.5 h-full bg-white bg-opacity-60 absolute"></div>

						{/* Slider Handle */}
						<div
							className="absolute w-4 h-4 bg-white rounded-full border-2 border-white pointer-events-none"
							style={{
								top: `${((1.5 - zoomLevel) / 0.7) * 80}px`,
								left: "50%",
								transform: "translate(-50%, -50%)",
							}}
						></div>

						{/* Invisible input for drag interaction */}
						<input
							type="range"
							min="0.8"
							max="1.5"
							step="0.01"
							value={zoomLevel}
							onChange={(e) => onZoomChange?.(parseFloat(e.target.value))}
							className="absolute w-6 h-20 opacity-0 cursor-pointer"
							style={{
								writingMode: "bt-lr",
								WebkitAppearance: "slider-vertical",
								width: "24px",
							}}
						/>
					</div>

					{/* Minus Button */}
					<button
						onClick={() => onZoomChange?.(Math.max(zoomLevel / 1.1, 0.8))}
						className="text-white p-1 hover:bg-white hover:bg-opacity-20 transition-colors rounded"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
						>
							<path d="M5 9V11H15V9H5Z" fill="white" />
						</svg>
					</button>
				</div>
			</div>

			{/* Bottom toolbar */}
			<div className="absolute bottom-0 left-0 right-0 z-10 p-2 flex justify-between items-center">
				{/* Animation controls - Only shown in Spot View */}
				{spotView && !isRecording && (
					<div className="flex items-center gap-2">
						<button
							onClick={onTogglePlay}
							className="bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60 transition-colors"
						>
							<ToolbarIcon
								iconName={animationState === "playing" ? "Pause" : "Play"}
							/>
						</button>
						{animationState === "stopped" && (
							<button
								onClick={onToggleShare}
								className="bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60 transition-colors"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="16"
									viewBox="0 0 20 16"
									fill="none"
								>
									<path
										d="M10 11H8C4.54202 11 1.53953 12.9502 0.0323901 15.8107C0.0109301 15.5433 0 15.2729 0 15C0 9.4772 4.47715 5 10 5V0L20 8L10 16V11Z"
										fill="white"
									/>
								</svg>
							</button>
						)}
						{animationState !== "stopped" && (
							<button
								onClick={onRestart}
								className="bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60 transition-colors"
							>
								<ToolbarIcon iconName="Restart" />
							</button>
						)}
					</div>
				)}
				<div
					className={`flex items-center gap-2 ${!spotView ? "ml-auto" : ""}`}
				>
					{/* Fullscreen Button */}
					<button
						onClick={onFullscreen}
						className="bg-black bg-opacity-40 text-white p-2 rounded-full hover:bg-opacity-60 transition-colors"
					>
						<ToolbarIcon iconName="Expand" />
					</button>
				</div>
			</div>
		</>
	);
};
